import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const LocationTracker = () => {
  const {
    location: { pathname },
  } = useHistory();

  useEffect(() => {
    if (window.analytics) {
      setTimeout(() => {
        window.analytics.page({
          path: pathname,
          title: document.title,
        });
      }, 300);
    }
  });
  return null;
};

export default LocationTracker;
